<template lang="pug">
div
  h1.h3.u-mb-sm.u-lineHeight Switcher

  CodeSample(name="Default" :pug="defaultPug" :html="defaultHtml" )
    label.switcher
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-handle


    label.switcher
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-true True
        span.switcher-false False
        span.switcher-handle


  CodeSample(name="Sizes" :pug="sizesPug" :html="sizesHtml" class="u-mt-md")
    label.switcher.is-tiny
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-handle

    label.switcher.is-small
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-handle

    label.switcher.is-normal
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-handle

    label.switcher.is-large
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-handle

    label.switcher.is-massive
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-handle



  CodeSample(name="Text" :pug="textPug" :html="textHtml" class="u-mt-md")
    label.switcher.is-tiny
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-true True
        span.switcher-false False
        span.switcher-handle

    br
    label.switcher.is-small
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-true Yes
        span.switcher-false No
        span.switcher-handle

    br
    label.switcher.is-normal
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-true Authorized
        span.switcher-false Unauthorized
        span.switcher-handle

    br
    label.switcher.is-large
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-true Authorized safely
        span.switcher-false Unauthorized safely
        span.switcher-handle

    br
    label.switcher.is-massive
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-true Authorized easily
        span.switcher-false Unauthorized easily
        span.switcher-handle



  CodeSample(name="Rounded" :pug="roundedPug" :html="roundedHtml" class="u-mt-md")
    .grid.is-6
      .column
        label.switcher.is-tiny.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-handle

        br
        label.switcher.is-small.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-handle

        br
        label.switcher.is-normal.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-handle

        br
        label.switcher.is-large.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-handle

        br
        label.switcher.is-massive.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-handle



      .column
        label.switcher.is-tiny.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-true True
            span.switcher-false False
            span.switcher-handle

        br
        label.switcher.is-small.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-true True
            span.switcher-false False
            span.switcher-handle

        br
        label.switcher.is-normal.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-true True
            span.switcher-false False
            span.switcher-handle

        br
        label.switcher.is-large.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-true True
            span.switcher-false False
            span.switcher-handle

        br
        label.switcher.is-massive.is-rounded
          input.switcher-input( type='checkbox')
          span.switcher-body
            span.switcher-true True
            span.switcher-false False
            span.switcher-handle


  CodeSample(name="Radio" :pug="radioPug" :html="radioHtml" class="u-mt-md")
    label.switcher
      input.switcher-input( type='radio' name="radio")
      span.switcher-body
        span.switcher-handle

    label.switcher
      input.switcher-input( type='radio' name="radio")
      span.switcher-body
        span.switcher-handle

    label.switcher
      input.switcher-input( type='radio' name="radio")
      span.switcher-body
        span.switcher-handle

    label.switcher
      input.switcher-input( type='radio' name="radio")
      span.switcher-body
        span.switcher-handle


  CodeSample(name="Disabled" :pug="disabledPug" :html="disabledHtml" class="u-mt-md")
    label.switcher.is-disabled
      input.switcher-input( type='checkbox')
      span.switcher-body
        span.switcher-handle


    label.switcher
        input.switcher-input( type='checkbox' disabled)
        span.switcher-body
          span.switcher-true True
          span.switcher-false False
          span.switcher-handle




  table.table.is-relaxed.u-mt-md
    thead
      tr
        th Modifier
        th Description
        th Class
    tbody

      tr
        td Size
        td changes the element size based on font-size
        td
          p .is-tiny
          p .is-small
          p .is-normal
          p .is-large
          p .is-massive

      tr
        td Rounded
        td add rounded corners to a switcher
        td .is-rounded
      tr
        td Disabled
        td indicates that a switcher is disabled, equivalent to `switcher[disabled]`
        td .is-disabled

  p.u-mt-md You can extend the switcher component features by adding the  #[AppLink(to="/brand/system/extensions/switcher" class="u-cl-primary") switcher extension.]
</template>

<script>
import CodeSample from '~/components/CodeSample';
// import switcher from '@baianat/base.extensions/switcher/dist/js/switcher';
export default {
  scrollToTop: true,
  layout: 'base',
  head: () => ({
    title: 'Switcher'
  }),
  components: {
    CodeSample
  },
  data: () => ({
    defaultPug: `label.switcher
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle

label.switcher
    input.switcher-input( type='checkbox')
    span.switcher-body
      span.switcher-true True
      span.switcher-false False
      span.switcher-handle`,

    defaultHtml: `<label class="switcher">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">True</span>
    <span class="switcher-false">False</span><span class="switcher-handle"><span></span>
</label>`,
    sizesPug: `label.switcher.is-tiny
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle

label.switcher.is-small
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle

label.switcher.is-normal
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle

label.switcher.is-large
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle

label.switcher.is-massive
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle`,

    sizesHtml: `<label class="switcher is-tiny">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-small">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-normal">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-large">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-massive">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>`,
    textPug: `label.switcher.is-tiny
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true True
    span.switcher-false False
    span.switcher-handle

label.switcher.is-small
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true Yes
    span.switcher-false No
    span.switcher-handle

label.switcher.is-normal
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true Authorized
    span.switcher-false Unauthorized
    span.switcher-handle

label.switcher.is-large
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true Authorized safely
    span.switcher-false Unauthorized safely
    span.switcher-handle

label.switcher.is-massive
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true Authorized easily
    span.switcher-false Unauthorized easily
    span.switcher-handle`,

    textHtml: `<label class="switcher is-tiny">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">True</span>
    <span class="switcher-false">False</span><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-small">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">Yes</span>
    <span class="switcher-false">No</span><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-normal">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">Authorized</span>
    <span class="switcher-false">Unauthorized</span><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-large">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">Authorized safely</span>
    <span class="switcher-false">Unauthorized safely</span><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-massive">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">Authorized easily</span>
    <span class="switcher-false">Unauthorized easily</span><span class="switcher-handle"><span></span>
</label>`,
    roundedPug: `label.switcher.is-tiny.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle

label.switcher.is-small.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher
label.switcher.is-normal.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle

label.switcher.is-large.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle

label.switcher.is-massive.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle


label.switcher.is-tiny.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true True
    span.switcher-false False
    span.switcher-handle

label.switcher.is-small.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true True
    span.switcher-false False
    span.switcher-handle

label.switcher.is-normal.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true True
    span.switcher-false False
    span.switcher-handle

label.switcher.is-large.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true True
    span.switcher-false False
    span.switcher-handle

label.switcher.is-massive.is-rounded
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-true True
    span.switcher-false False
    span.switcher-handle`,

    roundedHtml: `<label class="switcher is-tiny is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-small is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle">
</label>

<label class="switcher is-normal is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-large is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher is-massive is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>


<label class="switcher is-tiny is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">True</span>
    <span class="switcher-false">False</span>
    <span class="switcher-handle"><span></span>
</label>

<label class="switcher is-small is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">True</span>
    <span class="switcher-false">False</span>
    <span class="switcher-handle"><span></span>
</label>

<label class="switcher is-normal is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">True</span>
    <span class="switcher-false">False</span>
    <span class="switcher-handle"><span></span>
</label>

<label class="switcher is-large is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">True</span>
    <span class="switcher-false">False</span>
    <span class="switcher-handle"><span></span>
</label>

<label class="switcher is-massive is-rounded">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">True</span>
    <span class="switcher-false">False</span>
    <span class="switcher-handle"><span></span>
</label>`,
    radioPug: `label.switcher
  input.switcher-input( type='radio' name="radio")
  span.switcher-body
    span.switcher-handle

label.switcher
  input.switcher-input( type='radio' name="radio")
  span.switcher-body
    span.switcher-handle

label.switcher
  input.switcher-input( type='radio' name="radio")
  span.switcher-body
    span.switcher-handle

label.switcher
  input.switcher-input( type='radio' name="radio")
  span.switcher-body
    span.switcher-handle`,

    radioHtml: `<label class="switcher">
  <input type="radio" name="radio" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher">
  <input type="radio" name="radio" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher">
  <input type="radio" name="radio" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher">
  <input type="radio" name="radio" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>`,
    disabledPug: `label.switcher.is-disabled
  input.switcher-input( type='checkbox')
  span.switcher-body
    span.switcher-handle

label.switcher
    input.switcher-input( type='checkbox' disabled)
    span.switcher-body
      span.switcher-true True
      span.switcher-false False
      span.switcher-handle`,

    disabledHtml: `<label class="switcher is-disabled">
  <input type="checkbox" class="switcher-input"/><span class="switcher-body"><span class="switcher-handle"><span></span>
</label>

<label class="switcher">
  <input type="checkbox" disabled="disabled" class="switcher-input"/><span class="switcher-body">
    <span class="switcher-true">True</span>
    <span class="switcher-false">False</span><span class="switcher-handle"><span></span>
</label>`
  })
};
</script>
